import { Test, TestsService } from '../api';

interface MaterialTestProviderResource {
  getList: (
    resource: string,
    params: any
  ) => Promise<{ data: Test[] | undefined; total: number | undefined }>;
  getOne: (resource: string, params: any) => Promise<{ data: Test }>;
  create: (resource: string, params: any) => Promise<{ data: Test }>;
  update: (resource: string, params: any) => Promise<{ data: Test }>;
  delete: (resource: string, params: any) => Promise<{ data: {} }>;
  getMany: (resource: string, params: any) => Promise<{ data: Test[] }>;
  getManyReference: (
    resource: string,
    params: any
  ) => Promise<{ data: Test[] }>;
  updateMany: (resource: string, params: any) => Promise<{ data: Test[] }>;
  deleteMany: (resource: string, params: any) => Promise<{ data: {} }>;
}

export const materialTestsDataProvider: MaterialTestProviderResource = {
  getList: async (resource, params) => {
    const { pagination } = params;
    console.log('getList', pagination);
    const data = await TestsService.getTests();
    if (!data) {
      return {
        data: [],
        total: 0,
      };
    }
    return {
      data: data.items,
      total: data.items?.length,
    };
  },
  getOne: async (resource, params) => {
    const { id } = params;

    const test = await TestsService.getTest(id);
    return {
      data: test,
    };
  },
  create: async (resource, params) => {
    const test = await TestsService.addTest(params.data);
    return {
      data: test,
    };
  },
  update: async (resource, params) => {
    const test = await TestsService.updateTest(params.id, params.data);
    return {
      data: test,
    };
  },
  delete: async (resource, params) => {
    const { id } = params;
    await TestsService.deleteTest(id);
    return {
      data: {},
    };
  },
  getMany: async (resource, params) => ({
    data: [],
  }),
  getManyReference: async (resource, params) => ({
    data: [],
  }),
  updateMany: async (resource, params) => ({
    data: [],
  }),
  deleteMany: async (resource, params) => {
    // const promises = params.ids.map((id: number) => UserService.deleteUser(id));
    const promises = params.ids.map((id: number) => console.log(id));

    await Promise.all(promises);

    return {
      data: {},
    };
  },
};
